<template>
  <body class="u-body u-xl-mode" data-lang="en">
    <header class="u-clearfix u-header u-valign-bottom-sm u-valign-bottom-xs u-header" id="sec-social">
      <a href="#" class="u-image u-logo u-image-1" data-image-width="498" data-image-height="505" title="Home">
        <img src="../../../assets/warranty-images/logo-anewday_1full_color.webp" class="u-logo-image u-logo-image-1">
      </a>
    </header>

    <section class="u-align-center u-clearfix u-image u-shading u-section-1" id="sec-social-banner">
      <div class="u-clearfix u-sheet u-valign-middle-xs u-sheet-1">
        <h1 class="u-custom-font u-text u-title u-text-1">Social Media Bonus</h1>
        <p class="u-custom-font u-large-text u-text u-text-variant u-text-2">
          แชร์สินค้า Blackhole บน Social Media<br>เพื่อรับสิทธิ์ชิงโชคเพิ่มเติม
        </p>
      </div>
    </section>

    <section class="u-clearfix u-section-3" id="sec-social-form">
      <div class="u-clearfix u-sheet u-sheet-1">
        <div class="u-clearfix u-expanded-width u-gutter-0 u-layout-wrap u-layout-wrap-1">
          <div class="u-gutter-0 u-layout">
            <div class="u-layout-col">
              <div class="u-align-center u-container-style u-layout-cell u-radius-20 u-size-60 u-layout-cell-1">
                <div class="u-container-layout u-container-layout-1">

                  <!-- Success Message -->
                  <div v-if="isSuccess" class="px-8 py-10">
                    <div class="bg-green-100 rounded-lg py-8 px-6 text-center">
                      <svg class="w-16 h-16 mx-auto text-green-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <h3 class="text-xl font-semibold text-green-700 mb-2" style="font-family:Kanit">ส่งลิงก์สำเร็จ!</h3>
                      <p class="text-green-600" style="font-family:Kanit">ทีมงานจะตรวจสอบโพสต์ของคุณ หากผ่านจะได้รับสิทธิ์ Social Bonus เพิ่มเติม</p>
                    </div>
                  </div>

                  <!-- Form -->
                  <div v-else>
                    <h3 class="u-text u-text-1">ส่งลิงก์โพสต์ Social Media</h3>
                    <p class="u-custom-font" style="font-family:Kanit;color:#666;margin-bottom:20px">
                      โพสต์รีวิวสินค้า Blackhole บน Social Media แล้ววางลิงก์ที่นี่<br>
                      โพสต์ต้องตั้งค่าเป็น <strong>สาธารณะ (Public)</strong>
                    </p>

                    <!-- Error Alert -->
                    <div class="px-8 mt-3 mb-3">
                      <div v-if="errorMsg" class="bg-red-100 rounded-lg py-3 px-6 text-base text-red-700 inline-flex items-center w-full" role="alert">
                        <svg class="w-4 h-4 mr-2 fill-current" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>
                        {{ errorMsg }}
                      </div>
                    </div>

                    <div class="u-form u-form-1">
                      <form class="u-clearfix u-form-spacing-5 u-form-vertical u-inner-form" style="padding:0">

                        <!-- Serial Number: prefilled from the email URL but editable -->
                        <div class="u-form-group u-label-top">
                          <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">หมายเลขสินค้า / Serial Number : *</label>
                          <input v-model.trim="lotNo" type="text" maxlength="64" placeholder="กรอก Serial Number" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit" />
                        </div>

                        <!-- Social Platform -->
                        <div class="u-form-group u-label-top" style="margin-left:0">
                          <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">แพลตฟอร์ม / Platform : *</label>
                          <select v-model="socialPlatformId" :disabled="isLoadingPlatforms" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit;width:100%;height:42px">
                            <option value="" disabled>{{ isLoadingPlatforms ? 'กำลังโหลดแพลตฟอร์ม...' : '-- เลือกแพลตฟอร์ม --' }}</option>
                            <option v-for="platform in socialPlatforms" :key="platform.id" :value="platform.id">{{ platform.name }}</option>
                          </select>
                          <p v-if="platformLoadError" style="font-family:Kanit;font-size:0.8rem;color:#c53030;margin-top:4px">{{ platformLoadError }}</p>
                        </div>

                        <!-- Social Link -->
                        <div class="u-form-group u-label-top" style="margin-left:0">
                          <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">ลิงก์โพสต์ / Post URL : *</label>
                          <input v-model.trim="socialLink" type="url" placeholder="https://www.facebook.com/..." class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit" />
                          <p style="font-family:Kanit;font-size:0.8rem;color:#999;margin-top:4px">วางลิงก์โพสต์ที่ตั้งค่าเป็นสาธารณะ (Public)</p>
                        </div>

                        <!-- Consent for this Social Bonus submission -->
                        <div class="u-form-agree u-form-group u-label-top mt-3" style="margin-left:0">
                          <input id="social-consent" v-model="socialConsent" type="checkbox" class="u-agree-checkbox mr-3">
                          <label for="social-consent" class="u-agree-label u-custom-font u-label" style="font-family:Kanit">
                            ข้าพเจ้ายินยอมให้บริษัทเก็บรวบรวมและใช้ข้อมูลส่วนบุคคล รวมถึงลิงก์โพสต์ เพื่อเข้าร่วมกิจกรรม Social Bonus
                          </label>
                        </div>

                      </form>

                      <div class="u-align-left u-form-group u-form-submit u-label-top">
                        <a @click.prevent="submit" style="background-color:#f29802 !important" href="#"
                          :class="['u-active-palette-1-light-2 u-border-none u-btn u-btn-round u-btn-submit u-button-style u-custom-font u-hover-palette-1-light-1 u-palette-1-base u-radius-12 u-btn-1', isSubmitting ? 'opacity-50 pointer-events-none' : '']">
                          {{ isSubmitting ? 'กำลังส่ง...' : 'ส่งลิงก์ / Submit' }}
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </body>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SocialBonusForm',
  created() {
    document.title = "A New Day - Social Bonus"
  },
  async mounted() {
    await this.getSocialPlatforms()
  },
  data() {
    return {
      lotNo: (this.$route.params.lot_no || '').trim().toUpperCase(),
      socialPlatformId: '',
      socialPlatforms: [],
      isLoadingPlatforms: false,
      platformLoadError: '',
      socialLink: '',
      socialConsent: false,
      isSubmitting: false,
      isSuccess: false,
      errorMsg: ''
    }
  },
  methods: {
    async getSocialPlatforms() {
      this.isLoadingPlatforms = true
      this.platformLoadError = ''
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API}/anewday_get_sale_channels`,
          {}
        )
        if (res.data.resCode !== '00' || !Array.isArray(res.data.resData)) {
          throw new Error('Unable to load platforms')
        }

        this.socialPlatforms = res.data.resData.filter((platform) => (
          Number.isInteger(platform.id) && platform.id > 0 && platform.name
        ))
        if (!this.socialPlatforms.length) {
          throw new Error('No active platforms')
        }
      } catch (error) {
        this.socialPlatforms = []
        this.platformLoadError = 'ไม่สามารถโหลดรายการแพลตฟอร์มได้ กรุณาลองใหม่'
      } finally {
        this.isLoadingPlatforms = false
      }
    },

    async submit() {
      if (this.isSubmitting) {
        return
      }

      this.errorMsg = ''
      const lotNo = this.lotNo.trim().toUpperCase()

      if (!lotNo) {
        this.errorMsg = 'กรุณากรอกหมายเลขสินค้า / Serial Number'
        return
      }
      if (this.platformLoadError) {
        this.errorMsg = this.platformLoadError
        return
      }
      if (!this.socialPlatformId) {
        this.errorMsg = 'กรุณาเลือกแพลตฟอร์ม'
        return
      }
      if (!this.socialLink) {
        this.errorMsg = 'กรุณากรอกลิงก์โพสต์'
        return
      }
      if (!/^https:\/\/.+/i.test(this.socialLink)) {
        this.errorMsg = 'ลิงก์ไม่ถูกต้อง กรุณาใส่ URL ที่ขึ้นต้นด้วย https://'
        return
      }
      if (!this.socialConsent) {
        this.errorMsg = 'กรุณาให้ความยินยอมก่อนส่งข้อมูล'
        return
      }

      this.isSubmitting = true
      try {
        const res = await axios.post(`${process.env.VUE_APP_API}/anewday_submit_social_form`, {
          lot_no: lotNo,
          social_platform_id: this.socialPlatformId,
          social_link: this.socialLink.trim(),
          social_consent: this.socialConsent,
        })
        if (res.data.resCode === '00') {
          this.isSuccess = true
        } else if (res.data.resCode === '02') {
          this.errorMsg = 'ไม่พบข้อมูลการลงทะเบียน กรุณาตรวจสอบหมายเลขสินค้า'
        } else if (res.data.resCode === '03') {
          this.errorMsg = 'หมายเลขสินค้าไม่ถูกต้อง'
        } else if (res.data.resCode === '04') {
          this.errorMsg = 'กรุณาให้ความยินยอมก่อนส่งข้อมูล'
        } else {
          this.errorMsg = res.data.resDesc || 'เกิดข้อผิดพลาด กรุณาลองใหม่'
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errorMsg = 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง'
        } else {
          this.errorMsg = 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาลองใหม่'
        }
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>
